<template>
  <!-- Our Testimonials -->
  <section class="property-testimonial common-padding">
    <div class="testimonial-float-bg">
      <img src="@/assets/img/bg/testimonal-bg.png" alt="" />
    </div>
    <div class="container">
      <div class="section-heading section-heading-nine aos" data-aos="fade-up">
        <div class="row align-items-center">
          <div class="col-md-3"></div>
          <div
            class="col-md-6 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Our Testimonials</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit</p>
          </div>
          <div
            class="col-md-3 text-md-end aos aos-init aos-animate"
            data-aos="fade-up"
          ></div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 aos" data-aos="fade-up" data-aos-delay="200">
          <div class="car-class-carousel">
            <div class="verified-owner-slider owl-carousel" data-aos="fade-up">
              <Carousel
                :wrap-around="true"
                :settings="settings"
                :breakpoints="breakpoints"
              >
                <Slide v-for="item in IndexNineTestimonial" :key="item.id">
                  <div class="property-testimonial-item">
                    <h5 class="mb-0">{{ item.title }}</h5>
                    <div class="car-client-rating">
                      <i class="fa-solid fa-star"></i>
                      <i class="fa-solid fa-star"></i>
                      <i class="fa-solid fa-star"></i>
                      <i class="fa-solid fa-star"></i>
                      <i class="fa-solid fa-star"></i>
                    </div>
                    <p>{{ item.text }}</p>
                    <div class="property-profile-block">
                      <div class="property-profile">
                        <router-link to="profile"
                          ><img
                            :src="
                              require(`@/assets/img/profiles/${item.image}`)
                            "
                            class="img-fluid"
                            alt=""
                        /></router-link>
                      </div>
                      <div class="property-client-details">
                        <router-link to="profile">{{ item.name }}</router-link>
                        <span>{{ item.position }}</span>
                      </div>
                    </div>
                  </div>
                </Slide>
                <template #addons>
                  <Pagination />
                </template>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Our Testimonials -->

  <!-- Join Us -->
  <section class="buy-property aos" data-aos="fade-up">
    <div class="container">
      <div class="buy-property-content">
        <h2 class="aos" data-aos="fade-up" data-aos-delay="200">
          Join the millions getting more from their home.
        </h2>
        <p class="aos" data-aos="fade-up" data-aos-delay="400">
          With Listee, you can track properties you’re interested in and use our
          price estimates to help you decide when to move. And get expert tips
          on making the most of your space.
        </p>
        <router-link to="my-listing">List Your Space</router-link>
      </div>
    </div>
  </section>
  <!-- /Join Us -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexNineTestimonial from "@/assets/json/indexNineTestimonial.json";
export default {
  data() {
    return {
      IndexNineTestimonial: IndexNineTestimonial,
      Venue: ["Wedding Venue", "Reception", "Party Hall"],
      Location: ["Bangalore, India", "Delhi", "Hyderabad"],
      Guest: ["10", "20", "30"],
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },

      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 700px and up
        700: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1000: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  mouted() {},
};
</script>
